// extracted by mini-css-extract-plugin
module.exports = {"root":"news-page_root__1wKoz","content":"news-page_content__JALf7","pagination":"news-page_pagination__MHmJr"};